Storage = require 'lib/storage'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class OrganizationLinkGAHelperView extends View
  viewTitleKey: 'link google apps domain'

  events:
    'click .js-link': 'link'

  render: ->
    data = @model.toJSON()

    @$el.html(
      templates.fill(
        'org_link_ga_helper',
        data,
        { editable: @model.editable() }
      )
    )

    @

  link: ->
    track("Organization View", "Members Page", "Google Apps Marketplace link")

    if Storage.enabled()
      Storage.set 'idOrganizationLinking', @model.id

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-link-ga-helper-view.coffee